var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRetro = function SvgRetro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 780,
    height: 1440,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#retro_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D83F27",
    d: "M90 1050c0-81.93 30.42-152.76 92.97-216.51 53.22-54.24 123.42-97.35 191.34-139.05C505.8 613.71 630 537.48 630 390h-30c0 130.68-111.87 199.35-241.38 278.88C218.64 754.8 60 852.18 60 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6E8E",
    d: "M660 390c0 328.5-540 331.5-540 660h30c0-147.45 124.2-223.71 255.69-304.44 67.92-41.7 138.15-84.81 191.34-139.05C659.58 542.73 690 471.93 690 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142B53",
    d: "M630 390c0 147.45-124.2 223.71-255.69 304.44-67.92 41.7-138.15 84.81-191.34 139.05C120.42 897.27 90 968.07 90 1050h30c0-328.5 540-331.5 540-660z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8B98",
    d: "M150 1050c0-147.45 124.2-223.71 255.69-304.44 67.92-41.7 138.15-84.81 191.34-139.05C659.58 542.73 690 471.93 690 390h30c0 197.82-158.64 295.2-298.62 381.12C291.84 850.65 180 919.32 180 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82A8A0",
    d: "M720 390c0 197.82-158.64 295.2-298.62 381.12C291.84 850.65 180 919.32 180 1050h30c0-108.39 86.28-166.86 227.1-253.29 71.01-43.59 144.42-88.65 202.8-148.17C714 573 750.03 488.43 750.03 390H720"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA713C",
    d: "M600 390c0 130.68-111.87 199.35-241.38 278.88C218.64 754.8 60 852.18 60 1050H30c0-98.43 36.03-183 110.13-258.54 58.38-59.49 131.79-104.58 202.8-148.17 140.79-86.43 227.1-144.9 227.1-253.29h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDAA6C",
    d: "M540 390c0 42.39-14.97 75.72-50.04 111.48-40.29 41.1-99.78 77.61-162.75 116.25-72.54 44.55-147.57 90.6-208.5 152.73C39.93 850.74 0 944.82 0 1050h30c0-98.43 36.03-183 110.13-258.54 58.38-59.49 131.79-104.58 202.8-148.17 140.79-86.43 227.1-144.9 227.1-253.29H540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DEB3",
    d: "M210 1050c0-108.39 86.28-166.86 227.1-253.29 71.01-43.59 144.42-88.65 202.8-148.17C714 573 750.03 488.43 750.03 390h30c0 105.18-39.93 199.26-118.71 279.54-60.96 62.13-135.96 108.18-208.5 152.73-62.97 38.64-122.43 75.15-162.75 116.25-35.07 35.76-50.04 69.09-50.04 111.48H210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#retro_svg__b)",
    d: "M780 390c0 105.18-39.93 199.26-118.71 279.54-60.96 62.13-135.96 108.18-208.5 152.73-62.97 38.64-122.43 75.15-162.75 116.25C254.97 974.28 240 1007.61 240 1050H0c0-105.18 39.93-199.26 118.71-279.54 60.96-62.13 135.96-108.18 208.5-152.73 62.97-38.64 122.43-75.15 162.75-116.25C525.03 465.72 540 432.39 540 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82A8A0",
    d: "M600 1050c0 115.98-94.02 210-210 210s-210-94.02-210-210h30c0 99.42 80.58 180 180 180s180-80.58 180-180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DEB3",
    d: "M570 1050c0 99.42-80.58 180-180 180s-180-80.58-180-180h30c0 82.83 67.17 150 150 150s150-67.17 150-150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6E8E",
    d: "M660 1050c0 149.13-120.87 270-270 270s-270-120.87-270-270h30c0 132.54 107.46 240 240 240s240-107.46 240-240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8B98",
    d: "M630 1050c0 132.54-107.46 240-240 240s-240-107.46-240-240h30c0 115.98 94.02 210 210 210s210-94.02 210-210z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83F27",
    d: "M720 1050c0 182.25-147.75 330-330 330S60 1232.25 60 1050h30c0 165.69 134.31 300 300 300s300-134.31 300-300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142B53",
    d: "M690 1050c0 165.69-134.31 300-300 300S90 1215.69 90 1050h30c0 149.13 120.87 270 270 270s270-120.87 270-270z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDAA6C",
    d: "M750 1050c0 198.81-161.19 360-360 360S30 1248.81 30 1050H0c0 215.4 174.6 390 390 390s390-174.6 390-390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA713C",
    d: "M750 1050c0 198.81-161.19 360-360 360S30 1248.81 30 1050h30c0 182.25 147.75 330 330 330s330-147.75 330-330zM180 390c0-115.98 94.02-210 210-210s210 94.02 210 210h-30c0-99.42-80.58-180-180-180s-180 80.58-180 180z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDAA6C",
    d: "M210 390c0-99.42 80.58-180 180-180s180 80.58 180 180h-30c0-82.83-67.17-150-150-150s-150 67.17-150 150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142B53",
    d: "M120 390c0-149.13 120.87-270 270-270s270 120.87 270 270h-30c0-132.54-107.46-240-240-240S150 257.46 150 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83F27",
    d: "M150 390c0-132.54 107.46-240 240-240s240 107.46 240 240h-30c0-115.98-94.02-210-210-210s-210 94.02-210 210z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8B98",
    d: "M60 390C60 207.75 207.75 60 390 60s330 147.75 330 330h-30c0-165.69-134.31-300-300-300S90 224.31 90 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6E8E",
    d: "M90 390C90 224.31 224.31 90 390 90s300 134.31 300 300h-30c0-149.13-120.87-270-270-270S120 240.87 120 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DEB3",
    d: "M30 390C30 191.19 191.19 30 390 30s360 161.19 360 360h30C780 174.6 605.4 0 390 0S0 174.6 0 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82A8A0",
    d: "M30 390C30 191.19 191.19 30 390 30s360 161.19 360 360h-30c0-182.25-147.75-330-330-330S60 207.75 60 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B8B98",
    d: "M90 390c0 81.93 30.42 152.76 92.97 216.51 53.22 54.24 123.42 97.35 191.34 139.05C505.8 826.29 630 902.52 630 1050h-30c0-130.68-111.87-199.35-241.38-278.88C218.64 685.2 60 587.82 60 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#142B53",
    d: "M660 1050c0-328.5-540-331.5-540-660h30c0 147.45 124.2 223.71 255.69 304.44 67.92 41.7 138.15 84.81 191.34 139.05C659.58 897.27 690 968.07 690 1050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F6E8E",
    d: "M630 1050c0-147.45-124.2-223.71-255.69-304.44-67.92-41.7-138.15-84.81-191.34-139.05C120.42 542.73 90 471.93 90 390h30c0 328.5 540 331.5 540 660z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83F27",
    d: "M150 390c0 147.45 124.2 223.71 255.69 304.44 67.92 41.7 138.15 84.81 191.34 139.05C659.58 897.27 690 968.07 690 1050h30c0-197.82-158.64-295.2-298.62-381.12C291.84 589.35 180 520.68 180 390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA713C",
    d: "M720 1050c0-197.82-158.64-295.2-298.62-381.12C291.84 589.35 180 520.68 180 390h30c0 108.39 86.28 166.86 227.1 253.29 71.01 43.59 144.42 88.65 202.8 148.17C714 867 750.03 951.57 750.03 1050H720"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82A8A0",
    d: "M600 1050c0-130.68-111.87-199.35-241.38-278.88C218.64 685.2 60 587.82 60 390H30c0 98.43 36.03 183 110.13 258.54 58.38 59.49 131.79 104.58 202.8 148.17 140.79 86.43 227.1 144.9 227.1 253.29h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DEB3",
    d: "M540 1050c0-42.39-14.97-75.72-50.04-111.48-40.29-41.1-99.78-77.61-162.75-116.25-72.54-44.55-147.57-90.6-208.5-152.73C39.93 589.26 0 495.18 0 390h30c0 98.43 36.03 183 110.13 258.54 58.38 59.49 131.79 104.58 202.8 148.17 140.79 86.43 227.1 144.9 227.1 253.29H540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDAA6C",
    d: "M210 390c0 108.39 86.28 166.86 227.1 253.29 71.01 43.59 144.42 88.65 202.8 148.17C714 867 750.03 951.57 750.03 1050h30c0-105.18-39.93-199.26-118.71-279.54-60.96-62.13-135.96-108.18-208.5-152.73-62.97-38.64-122.43-75.15-162.75-116.25C255 465.72 240.03 432.39 240.03 390H210"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "retro_svg__b",
    x1: 390,
    x2: 390,
    y1: 1050,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#272727",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272727",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "retro_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 1440V0h780v1440z"
  })))));
};
export default SvgRetro;